import { clsx } from "clsx"

/** Shared chrome for the Loan Product picker and Battery's offer pickers. */

export type Tone = `danger` | `muted` | `ok` | `warn`

const PILL_TONE: Record<Tone, string> = {
  ok: `border-bp-success/40 bg-bp-success/10 text-bp-success`,
  warn: `border-bp-gold/40 bg-bp-gold/10 text-bp-gold`,
  danger: `border-bp-danger/40 bg-bp-danger/10 text-bp-danger`,
  muted: `border-bp-border-strong bg-bp-elevated text-bp-text-muted`,
}

export const Pill = ({
  tone,
  children,
}: {
  tone: Tone
  children: React.ReactNode
}): JSX.Element => (
  <span
    className={clsx(
      `inline-flex items-center rounded-full border px-2 py-0.5 text-[length:var(--step--3)] font-semibold tracking-[0.12em] uppercase whitespace-nowrap`,
      PILL_TONE[tone],
    )}
  >
    {children}
  </span>
)

export const sectionLabelClass = `font-display text-[length:var(--step-0)] font-semibold text-bp-text`
export const btnSecondary = `rounded-md border border-bp-border-strong px-4 py-2 text-[length:var(--step--1)] font-medium text-bp-text-soft transition-colors hover:border-bp-accent hover:text-bp-text disabled:cursor-not-allowed disabled:opacity-50`
export const btnPrimary = `rounded-md bg-bp-accent px-4 py-2 text-[length:var(--step--1)] font-semibold text-bp-on-accent transition-colors hover:bg-bp-accent-hover disabled:cursor-not-allowed disabled:opacity-50`
export const btnLink = `self-start rounded-md border border-bp-border-strong px-3 py-1.5 text-[length:var(--step--2)] font-medium text-bp-text-soft transition-colors hover:border-bp-accent hover:text-bp-text`

/** Money as the server sent it, to the cent. Nothing here derives a payment. */
export const monthlyUsd = new Intl.NumberFormat(`en-US`, {
  style: `currency`,
  currency: `USD`,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})
